module.exports = __webpack_public_path__ + "static/img/function_button.fda01d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus_se/function_button.png
// module id = +cP7
// module chunks = 1